import { useQuery } from '@tanstack/react-query';
import { partnerApi } from '../lib/api';
import type { SchemaLookupConflict } from './schemaFieldRemoval';
import { SchemaLookupConflictItem } from './SchemaLookupConflictItem';
import styles from './SchemaDefinitionsWithMappings.module.css';

interface SchemaLookupConflictListProps {
  conflicts: SchemaLookupConflict[];
}

// One bounded list avoids a lookup request per unnamed conflict.
const TOOL_NAME_LOOKUP_LIMIT = 100;

export const SchemaLookupConflictList = ({ conflicts }: SchemaLookupConflictListProps) => {
  const someConflictIsUnnamed = conflicts.some(conflict => !conflict.toolName);
  const toolsQuery = useQuery({
    queryKey: ['ai-tools', { status: 'active', limit: TOOL_NAME_LOOKUP_LIMIT }],
    queryFn: () => partnerApi.getTools({ status: 'active', limit: TOOL_NAME_LOOKUP_LIMIT }),
    enabled: someConflictIsUnnamed,
  });
  const namesByToolId = new Map(
    (toolsQuery.data?.tools ?? []).map(tool => [tool.id, tool.display_name]),
  );
  const conflictItems = conflicts.map(conflict => ({
    conflict,
    key: [
      conflict.toolDefinitionId,
      conflict.schemaDefinitionId,
      conflict.fieldName,
      conflict.reason,
    ].join('-'),
    toolName:
      conflict.toolName || namesByToolId.get(conflict.toolDefinitionId) || conflict.toolDefinitionId,
  }));

  return (
    <section className={styles.schemaLookupConflicts}>
      <h4>Active lookup tools must be updated or disabled first</h4>
      <ul>
        {conflictItems.map(({ conflict, key, toolName }) => (
          <SchemaLookupConflictItem key={key} conflict={conflict} toolName={toolName} />
        ))}
      </ul>
    </section>
  );
};
